import React from "react"
import styled from "styled-components"

const Title = styled.h1`
  color: #7e7e7e;
  font-size: 1.2rem;
  font-weight: 600;
`;

const GreyText = styled.span`
  color: #7e7e7e;
  font-weight: 600;
`;

const Text = styled.p`
  color: #000;
`;

const Container = styled.main`
  background: #fff;
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: 0 1rem;
  overflow-y: scroll;
`;

const List = styled.ul`
  color: #000;
`;

const NumList = styled.ol`
  color: #000;
`;

const TabelContainer = styled.div`
  @media screen and (max-width: 720px) {
    max-width: 95vw;
    overflow-x: scroll;
  }
`;

const Table = styled.table`
`;

const TableHead = styled.th`
  background-color: #000;
  color: #fff;
`;

const TableBody = styled.td`
  color: #000;
  border: solid #000 1px;
  padding: 5px;
`;

const TableRow = styled.tr``;

const Box = styled.div`
  border: solid #000 3px;
  padding: 1.5rem;
`;

export const TempLegalDocHtml = () => {
  return (
    <Container>
      <Title>Privacy Statement</Title>
      <Text>
        <GreyText>Introduction. CROPWISE </GreyText>
        is managed by Syngenta Crop Protection, LLC (Syngenta) - the
        “data controller”. Your privacy is important to us. Syngenta has therefore developed this
        privacy statement (this “Statement” or “Privacy Statement”) to inform you how Syngenta
        collects, stores, uses and processes the personal data and information you provide us through
        this website.
      </Text>
      <Text>
        <GreyText>Effective date. </GreyText>January 1, 2023
      </Text>
      <Text>
        <GreyText>Scope of this Statement. </GreyText>
        This Statement covers the personal data and information
        (hereinafter “Personal Information”) we collect through this site. Personal Information is data
        that identifies you personally, either alone or in combination with other information available to
        us. Examples of Personal Information include your name, address, email address, tax
        identification number, if applicable, and the information you provide when you use our site to
        create an account or a personal profile.
      </Text>
      <Text>
        <GreyText>Your consent. </GreyText>
        By using this site you are accepting the practices described in this Statement
        (including the Cookies Policy available on this site). If you do not agree to this Statement or the
        Cookies Policy, please do not use this site. We reserve the right to make changes to this
        Statement or the Cookies Policy at any time. Any changes will be posted in this Statement or
        the Cookies Policy and material changes will generally apply only to activities and information
        collected on a going forward basis. We encourage you to regularly review this Statement and
        the Cookies Policy to make sure you are aware of any changes and how your information may
        be used.
      </Text>
      <GreyText>What Personal Information do we collect through our site?</GreyText>
      <Text>
        Personal Information refers to information that lets us know the specifics of who you are.
        Personal Information is requested when you order a service, register for an account and send
        us feedback. For example, this information might include your name, address (both billing and
        registered), email address, industry and product details, and credit card or other payment
        information. Such information may be held on our contacts and administration databases either
        because of the work we have done with you or are currently engaged in, or because we believe
        you might be interested in receiving material from us about our business, products, programs
        and services. This allows us to manage our relationship with you efficiently, improve our site
        and the services which we offer to you and to target items of interest we may send to you.
      </Text>
      <Text>
        Non-personally identifiable information refers to information that is statistical in nature only and
        that does not, by itself, allow to identify a specific individual or entity, and which depends upon
        the visiting you do on the site. For example, this information may include the domain from which
        you access the internet, the date and time you access the site, and the internet address of the
        website from which you linked directly to the site. This information is used in an aggregate form
        to make the site more useful and attractive to its users.
      </Text>
      <GreyText>
        Agreements governing your use of special features and password-protected areas.
      </GreyText>
      <Text>
        This site may include special features and password-protected areas. When you sign up to use
        a special feature or password-protected area, you may be asked to agree to special terms
        governing your use of the special feature or password-protected area. In such cases, you will be
        asked to expressly consent to the special terms, for example, by checking a box or clicking on a
        button marked "I agree." This type of agreement is known as a "click-through" agreement. If any
        of the terms of the click-through agreement are different than the terms of this Statement, the
        terms of the click-through agreement will supplement or amend this Statement, but only with
        respect to the matters governed by the "click-through agreement."
      </Text>
      <GreyText>
        Cookies and similar technologies.
      </GreyText>
      <Text>
        We use "cookies" and other web technologies to collect information and support certain features
        of our sites. “Cookies” provides us with information about the ways visitors use our sites – which
        pages they visit in what order, which links they use, and how long they stay on each page
      </Text>
      <Text>We do this to:</Text>
      <List>
        <li>
          analyze and improve the effectiveness of our advertising campaigns;
        </li>
        <li>
          support and enhance the features and functionality of our sites – for example, to save
          you the trouble of reentering information already in our database or to prompt the
          settings you established on previous visits to our sites; and
        </li>
        <li>
          personalize your experience when you use our sites.
        </li>
      </List>
      <Text>
        Generally, the information we collect using these web technologies does not identify you
        personally.
      </Text>
      <Text>
        If, however, you have created a user identity, for example, by signing up to use a passwordprotected area on one of our sites, we may link the information we collect using web
        technologies to other information that identifies you personally
      </Text>
      <Text>
        If you do not wish to receive cookies, you may set your browser to reject cookies or to alert you
        when a cookie is placed on your computer. You may also delete our cookies as soon as you
        leave a site. Although you are not required to accept our cookies when you visit our sites, if you
        set your browser to reject cookies, you will not be able to use all of the features and functionality
        of our sites. Please see the Cookies Policy on this site for more details.
      </Text>
      <GreyText>How does Syngenta use your Personal Information?</GreyText>
      <Text>Generally, we use the Personal Information we collect through our site:</Text>
      <List>
        <li>To provide the products, information and services you request from us</li>
        <li>For security, credit or fraud prevention purposes or any other legal obligation;</li>
        <li>
          To contact you with special offers and other information we believe will be of interest to
          you where you have given us permission to do so
        </li>
        <li>
          Based upon a legitimate interest we have:
          <List>
            <li>To provide you with effective customer service;</li>
            <li>To provide you with a personalized experience when you use our site; </li>
            <li>To display personalized advertising when you visit our site; </li>
            <li>To contact you with information and notices related to your use of our site; </li>
            <li>To invite you to participate in surveys and provide feedback to us; </li>
            <li>To better understand your needs and interests; </li>
            <li>To improve the content, functionality and usability of our site; </li>
            <li>To improve our products and services; </li>
            <li>To improve our marketing and promotional efforts; and </li>
          </List>
        </li>
        <li>
          For any other purpose identified in an applicable privacy notice or other agreement
          between Syngenta and you.
        </li>
      </List>
      <GreyText>How does Syngenta disclose my Personal Information?</GreyText>
      <Text>
        <u>Service providers.</u> We disclose Personal Information to companies and organizations that
        perform services on our behalf, for example, companies that provide support services to us
        (such as credit card processing services, data storage services, and web hosting services) or
        that help us market our products and services (such as third-party e-mail marketing companies).
        These third parties are required by contract to use the Personal Information we disclose to them
        only to perform services on our behalf and to take commercially reasonable measures to protect
        the confidentiality and security of your Personal Information.
      </Text>
      <Text>
        <u>Within Syngenta.</u> We may disclose the Personal Information we collect through our Site within
        Syngenta or with other North America affiliates of Syngenta for cross-marketing and other
        purposes. If you do not want us to disclose your Personal Information with another member of
        the Syngenta North America family of businesses you may "opt-out" at any time by sending an
        email or writing to our data privacy officer – see the contact details on this page.
      </Text>
      <Text>
        <u>Business transfers.</u> Your Personal Information may be transferred to a company that has
        acquired the stock or assets of Syngenta, one of its affiliates, or one of our businesses, for
        example, as the result of a sale, merger, reorganization or liquidation. If such a transfer occurs,
        the acquiring company's use of your Personal Information will still be subject to this policy and
        the privacy preferences you have expressed to us.
      </Text>
      <Text>
        <u>Compliance with laws and protection of our rights and the rights of others.</u> We may disclose
        Personal Information when we, in good faith, believe disclosure is appropriate to comply with
        the law, a court order or a subpoena. We may also disclose Personal Information to prevent or
        investigate a possible crime, such as fraud or identity theft; to enforce or apply our online terms
        of use or other agreements; or to protect our own rights or property or the rights, property or
        safety of our users or others.
      </Text>
      <Text>
        <u>Aggregate information.</u> We may disclose aggregated demographic or survey information with
        third parties, but this information is in anonymous form and does not contain any Personal
        Information. The aggregate information that we disclose may include anonymous information
        that is captured through the use of cookies and other similar tracking technology, as explained
        in the section entitled “cookies and similar technologies.”
      </Text>
      <Text>
        <u>As described in a privacy notice.</u> We reserve the right to disclose your Personal Information as
        described in any additional privacy notice posted on the web page (or area) where you provide
        that information. By providing your Personal Information on that web page you will be
        consenting to the disclosure of your Personal Information as described in that privacy notice.
        As described in a click-through agreement. We reserve the right to disclose your Personal
        Information as described in any click-through agreement to which you have agreed.
      </Text>
      <GreyText>
        Your choices
      </GreyText>
      <Text>
        <u>In general</u><br />
        We respect your right to make choices about the ways we collect, use and disclose your
        Personal Information. In most cases, we will ask you to indicate your choices at the time we
        collect your Personal Information. We will also include an "opt-out" link in newsletter or
        promotional email we send you so that you can inform us that you do not wish to receive such
        communications from us in the future. If you have created an account or a personal profile on
        our site, you may be able to update some or all of your privacy choices by changing the settings
        on your account settings or profile page.
      </Text>
      <Text>
        <u>Direct marketing</u><br />
        Before we use your Personal Information for direct marketing purposes (or permit our affiliates
        to do so), we will offer you the opportunity to choose whether to have your information used in
        this way. If at any time you wish to be taken off our direct marketing mailing lists, please send
        an email or write to our Data Protection Officer– see the contact details on this page. Please
        provide your full name, address and email address so that we can find you on our mailing lists.
        Once we have the information we need, we will remove you from our mailing lists. Please give
        us a reasonable amount of time to honor your request.
      </Text>
      <Text>
        <u>Disclosing your personal information.</u><br />
        Please review the section entitled "how does Syngenta disclose my Personal Information?" to
        learn how we may disclose your Personal Information with third parties and what choices you
        have.
      </Text>
      <GreyText>How can you exercise your rights in relation to your Personal Information?</GreyText>
      <Text>
        We strive to maintain a high level of transparency about the data we process. As regards our
        processing of your Personal Information described in this Statement, you have the following
        rights:
      </Text>
      <List>
        <li>
          To confirm Syngenta is processing your Personal Information, to get access to or
          receive a copy of the Personal Information we may have about you;
        </li>
        <li>
          To require us to rectify or update any inaccurate Personal Information, or complete any
          incomplete Personal Information;
        </li>
        <li>
          To require us to delete or erase your Personal Information;
        </li>
        <li>
          To restrict our processing of your Personal Information;
        </li>
        <li>
          To require us to transmit certain of your Personal Information to you or to transfer or
          have the information transferred to another data controller (data portability); and
        </li>
        <li>
          To require that we stop processing your Personal Information for direct marketing
          purposes. Subject to other legitimate interests which we may be able to rely on (e.g. in
          the context of legal claims pending or threatened against us), we will then no longer be
          allowed to process your Personal Information
        </li>
      </List>
      <Text>
        If you wish to exercise any of your above rights, you can contact us at no cost by sending an
        email to the Data Protection Officer – see the contact details on this page.
      </Text>
      <Text>
        We will respond to your reasonably specified request as quickly as possible after validating the
        request.
      </Text>
      <Text>
        We will without undue delay modify your Personal Information if we agree that it is either
        inaccurate, out of date, incomplete, irrelevant or misleading, after taking into account the
        purposes for which it was collected. If we correct it and had previously disclosed it to a third
        party, we will also notify that third party if required to by law.
      </Text>
      <Text>
        If we disagree with your request to correct your Personal Information, we will explain the reason
        for refusal and the ways you can complain.
      </Text>
      <GreyText>How long does Syngenta store your Personal Information?</GreyText>
      <Text>
        We intend to keep your Personal Information accurate and up-to-date. We do not wish to store
        your Personal Information for any longer than necessary for the relevant purposes in relation to
        the use of our Website. How long we need to keep your Personal Information depends on the
        purpose for which we collect it, and therefore there is no standard retention period. Thus, the
        retention period may vary depending on the circumstances. For other legal reasons, e.g. in the
        context of legal claims, we may need hold Personal Information beyond the term required to
        meet the defined purpose for which they were collected in the first place. However, in these
        cases we will no longer actively process the Personal Information for the originally specified
        purpose.<br />
        Should you wish to obtain more information on where and how long your Personal Information is
        stored, and on your right of erasure please contact our Global Data Protection Officer – see
        contact details on this page.
      </Text>
      <GreyText>

        How does Syngenta protect Personal Information?
      </GreyText>
      <Text>
        We maintain a comprehensive data security program, including commercially reasonable
        administrative, physical and technological security measures, to protect Personal Information
        from unauthorized access, unauthorized use, and unauthorized or accidental destruction,
        modification or disclosure. Although we take commercially reasonable precautions to provide an
        appropriate level of security, we cannot guarantee the security of Personal Information provided
        over the internet or stored in our databases.
      </Text>
      <GreyText>
        Links to other Syngenta websites
      </GreyText>
      <Text>
        This Site may contain hyperlinks to other websites operated by Syngenta or other Syngenta
        entities ("Other Syngenta Website(s)"). These Other Syngenta Websites are separate and
        distinct websites. Each serves a different purpose. Each Other Syngenta Website is therefore
        governed by its own terms of use and its own privacy statement. If you access Other Syngenta
        Websites through links on this site, please take a few minutes to review the terms of use and
        privacy statement posted on each Other Syngenta Website you visit.
      </Text>
      <GreyText>
        Links to other web sites
      </GreyText>
      <Text>
        This site may contain links to web sites operated by other companies, including websites
        operated by our third-party service providers, our affiliates, and other third parties. This
        Statement does not apply to Personal Information collected on any of these third-party web
        sites. When you access third-party web sites through a link on this site, please take a few
        minutes to review the privacy policy posted on that site.
      </Text>
      <GreyText>
        Children
      </GreyText>
      <Text>
        Our Site is not directed nor targeted to children under the age of 13. We do not use our Site to
        knowingly solicit Personal Information from, or market to, children under the age of 13. If you
        are under the age of 13, do not provide us with any Personal Information. If we learn that
        someone under 13 has provided Personal Information through one of our sites, we will use
        reasonable efforts to remove such Personal Information from our databases.
      </Text>
      <GreyText>
        Special notice for visitors who reside outside the United States
      </GreyText>
      <Text>
        Syngenta uses web servers and stores data in Switzerland, France, the United States or in
        other countries. We may transfer your Personal Information to our service providers and others
        located in Switzerland, France, the United States or other countries for the purposes described
        in this Statement. Different countries have different privacy laws and requirements, and some
        provide less legal protection for your personal information than others.
      </Text>
      <Text>
        Please know, however, that no matter where your Personal Information is collected or
        processed, if it was collected through this Site, we will ensure that it is protected by the terms of
        this Statement and any privacy notices or click-through agreements that apply to you.
      </Text>
      <Text>
        By using this site, you are consenting to the collection, use, and transfer of your Personal
        Information in or to the United States or any other country in the world.
      </Text>
      <GreyText>Governing law & Jurisdiction</GreyText>
      <Text>
        This Statement is governed under the laws of Delaware without regard to its conflicts of law
        provisions. The United States District Court for the District of Delaware, Wilmington, Delaware,
        shall have exclusive jurisdiction for any claims relating to these Statement.
      </Text>
      <GreyText>Questions, concerns and complaints concerning our privacy practices</GreyText>
      <Text>
        Should you have any question or concern on how Syngenta utilizes your Personal Information,
        you can contact our Data Protection Officer – see the contact details on this page.
      </Text>
      <Text>
        You also have a right to lodge a complaint with the relevant supervisory authority (in particular
        in the State of your habitual residence, place of work or place of the alleged infringement).
      </Text>
      <GreyText>Requests:</GreyText>
      <Text>To exercise your privacy rights:</Text>
      <NumList>
        <li>To know what personal information is collected about you through this site;</li>
        <li>To access any personal information collected about you;</li>
        <li>To Opt out of the sale of your personal information;</li>
        <li>The return of any personal information collected about through this site;</li>
        <li>The deletion of any personal information collected about you through this site</li>
      </NumList>
      Contact the Global Data Privacy Officer:
      <a href="mailto:Data.privacy@syngenta.com">Data.privacy@syngenta.com</a>
      <GreyText>Additional Information for Regional U.S. Consumers (“Notice”)</GreyText><br />
      <Text>
        This Notice further explains how we collect, use, and disclose your Personal Information. It
        also describes how to exercise your rights under the California Consumer Privacy Act
        (“CCPA”), the Colorado Privacy Act, the Connecticut Act Concerning Personal Data Privacy
        and Online Monitoring, the Utah Consumer Privacy Act, and the Virginia Consumer Data
        Protection Act. Syngenta refers to those laws collectively the “U.S. Privacy Laws”.<br />
        When Syngenta references “Personal Information” in this Notice, that is information that
        identifies, relates to, describes, is reasonably capable of being associated with, or could
        reasonably be linked with consumers, directly or indirectly. Personal Information does not
        include information that cannot be reasonably linked to you. In addition, in this Notice we use
        certain defined terms, which we have capitalized. These capitalized terms have the meaning
        given to them in our Terms & Conditions, which form part of the Agreement between us and
        you.
      </Text>
      <GreyText>How Syngenta may collect, use, and disclose Personal Information<br /></GreyText>
      <Text>
        The chart below shows the categories of Personal Information we may collect through Cropwise,
        examples of the types of Personal Information in each category; the types of sources from which
        each category of Personal Information is collected; the business purpose(s) for which that
        category of Personal Information is collected as well as the types of third parties with whom that
        category of Personal Information is disclosed. This information covers the past 12 months.
      </Text>
      <TabelContainer>
        <Table>
          <TableRow>
            <TableHead>
              Categories of Personal Information Collected
            </TableHead>
            <TableHead>
              Examples of
              Personal
              Information
              Collected
            </TableHead>
            <TableHead>
              Categories of
              Sources from
              which personal
              information is
              collected
            </TableHead>
            <TableHead>
              Business or commercial
              purposes for collection
              and disclosure
            </TableHead>
            <TableHead>
              Categories of third
              parties to whom
              Personal
              Information is
              disclosed
            </TableHead>
            <TableHead>
              Intended Data
              Retention Period
            </TableHead>
          </TableRow>
          <TableRow>
            <TableBody><GreyText>Identifiers</GreyText></TableBody>
            <TableBody>
              Your real name, alias, email address, business name, a description of who you are, postal address, telephone number,
              password for your Account.
            </TableBody>
            <TableBody>
              Directly from a
              consumer
            </TableBody>
            <TableBody>
              We use this personal
              information to:
              <List>
                <li>register and set up your Account and provide the Products;</li>
                <li>provide technical and customer support.</li>
              </List>
            </TableBody>
            <TableBody>
              As described in the section entitled “How does Syngenta disclose my Personal Information?”
            </TableBody>
            <TableBody>
              As long as required for the business purpose or as legally required
            </TableBody>
          </TableRow>
          <TableRow>
            <TableBody><GreyText>Identifiers</GreyText></TableBody>
            <TableBody>
              Your real name, alias,
              email address,
              business name, a
              description of who
              you are, address,
              telephone number.
            </TableBody>
            <TableBody>
              Directly from a
              consumer
            </TableBody>
            <TableBody>
              We use this personal
              information to:
              <List>
                <li>communicate with you via email, text or in app notifications about updates to the Product or other important functional service messages;</li>
                <li>send you user satisfactions surveys and to ask for your feedback about the Products.</li>
              </List>
            </TableBody>
            <TableBody>
              As described in the
              section entitled “How
              does Syngenta
              disclose my
              Personal
              Information?”
            </TableBody>
            <TableBody>
              As long as required
              for the business
              purpose or as legally
              required
            </TableBody>
          </TableRow>
          <TableRow>
            <TableBody><GreyText>Internet Activity</GreyText></TableBody>
            <TableBody>
              If you use a mobile app Product, the information regarding your interaction with the application,
              including the date and time the app on your device accesses our servers and what information and
              files have been downloaded to the app.
            </TableBody>
            <TableBody>
              Directly from a consumer or acquired via digital process
            </TableBody>
            <TableBody>
              We use this information:
              <li>
                for maintenance of the app;
              </li>
              <li>
                for statistical purposes about the usage of these apps in order to improve their functionality;
              </li>
              <li>
                to understand how they are used and resolve questions regarding their use;
              </li>
              <li>
                for security purposes. The developer of your mobile operating system (e.g. Apple; Google)
                may also collect app usage data. You should refer to their privacy notices and policies for more information.
              </li>
              The developer of your
              mobile operating system
              (e.g. Apple; Google) may
              also collect app usage data.
              You should refer to their
              privacy notices and policies
              for more information.
            </TableBody>
            <TableBody>
              As described in the section entitled “How does Syngenta disclose my Personal Information?”
            </TableBody>
            <TableBody>
              As long as required for the business purpose or as legally required
            </TableBody>
          </TableRow>
          <TableRow>
            <TableBody>
              <GreyText>
                Internet Activity and Identifiers
              </GreyText>
            </TableBody>
            <TableBody>
              If you use an online
              service in connection
              with a Product, the
              following will be
              collected: computer
              type (Windows or
              Macintosh), operating
              system name and
              version, language,
              internet browser type
              and version and the
              name and version of
              the online services
              you are using,
              Internet Protocol
              address,
              browsing/search
              history (page(s)
              visited and time).
            </TableBody>
            <TableBody>
              Directly from a
              consumer or
              acquired via digital
              process. <br />
              From Service
              Providers or from
              publicly-available
              information.
            </TableBody>
            <TableBody>
              We use this information to:
              <List>
                <li>provide the Products to our users;</li>
                <li>to ensure they work properly;</li>
                <li>to calculate usage level;</li>
                <li>to help diagnose server problems;</li>
                <li>for statistical purposes about usage of online services;</li>
                <li>for security purposes.</li>
              </List>
            </TableBody>
            <TableBody>
              As described in the
              section entitled “How
              does Syngenta
              disclose my
              Personal
              Information?”
            </TableBody>
            <TableBody>
              As long as required
              for the business
              purpose or as legally
              required
            </TableBody>
          </TableRow>
          <TableRow>
            <TableBody>
              <GreyText>
                Internet
                Activity,
                Customer
                Records,
                Inferences
                and
                Identifiers
              </GreyText>
            </TableBody>
            <TableBody>
              Contact information, as well as information about your interaction with the Products.
            </TableBody>
            <TableBody>
              Directly from a consumer or acquired via digital process.<br />
              From Service Providers or from publicly-available information.<br />
              Internal<br />
            </TableBody>
            <TableBody>
              Customer profiling and
              marketing - we will process
              this data (and other
              information that you have
              provided to us through using
              other Syngenta products or
              services) to understand how
              you have used the Products,
              and what your agricultural
              needs are. We may then
              contact you (as a
              representative of your
              Business) with relevant
              information about other
              Syngenta products and
              services we think may be of
              interest to your business.
              Where required by
              applicable law, we will obtain
              your consent for marketing
              purposes, and in any case,
              you can stop direct
              marketing at any time by
              contacting us as set out
              below, or by using the
              unsubscribe link in our
              emails.
            </TableBody>
            <TableBody>
              As described in the
              section entitled “How
              does Syngenta
              disclose my
              Personal
              Information?”
            </TableBody>
            <TableBody>
              As long as required
              for the business
              purpose or as legally
              required
            </TableBody>
          </TableRow>
          <TableRow>
            <TableBody>
              <GreyText>
                Internet Activity and Identifiers
              </GreyText>
            </TableBody>
            <TableBody>
              Your real name, alias,
              email address and
              device specific
              identifiers, (computer
              type (Windows or
              Macintosh), operating
              system name and
              version, language,
              internet browser type
              and version and the
              name and version of
              the online services
              you are using,
              Internet Protocol
              address,
              browsing/search
              history (the page(s)
              visited and time
              visited).
            </TableBody>
            <TableBody>
              Directly from a
              consumer or
              acquired via digital
              process. <br />
              From Service
              Providers or from
              publicly-available
              information.
            </TableBody>
            <TableBody>
              We use "cookies" and other similar technologies to collect information and support certain features of our Products.
              We use this information to:
              <li>provide the Products (including mobile apps) to our users;</li>
              <li>for maintenance, to ensure the Products work properly;</li>
              <li>
                to calculate usage level, for statistical purposes about the usage of our Products and online services in order
                to improve their functionality;
              </li>
              <li>to help diagnose server problems;</li>
              <li>to understand how our Products are used</li>
              <li>to resolve questions regarding their use;</li>
              <li>for security purposes.</li>
            </TableBody>
            <TableBody>
              As described in the section entitled “How does Syngenta disclose my Personal Information?”
            </TableBody>
            <TableBody>
              As long as required for the business purpose or as legally required
            </TableBody>
          </TableRow>
        </Table>
      </TabelContainer>
      <br />
      <Text>
        We do not sell or disclose your Cropwise personal information in exchange for money, and we
        have not 'sold' or 'shared' (as those terms are defined by the CCPA) your Cropwise personal
        information in the preceding 12 months. Our use of sensitive personal data collected through
        Cropwise (if any) is limited to use which is necessary to provide the Products.
      </Text>
      <GreyText>How can you exercise your rights provided under the U.S. Privacy Laws? </GreyText><br />
      <Text>
        Depending on where you live, and subject to certain exceptions, you may have some or all of
        the following rights:
      </Text>
      <List>
        <li>
          <GreyText>Right to Know:</GreyText> The right to request that we disclose to you the Personal Information we
          collect, use, or disclose, and information about our data practices. This includes the right
          to request certain information regarding the Personal Information we have collected
          about you in the preceding 12 months including (1) the specific pieces and categories of
          Personal Information collected about you; (2) the categories of sources providing that
          Personal Information; (3) the categories of personal information disclosed and the third
          parties to whom we have disclosed that Personal Information; and/or (4) the business
          purposes for collecting, selling and sharing that Personal Information.
        </li>
        <li>
          <GreyText>Right to Request Correction:</GreyText> The right to request that we correct inaccurate Personal Information that
          we maintain about you.
        </li>
        <li>
          <GreyText>Right to Request Deletion:</GreyText> The right to request that we delete your Personal Information that we have collected
          from or about you.
        </li>
        <li>
          <GreyText>Right to Opt Out of Targeted Advertising:</GreyText> The right to opt out of certain processing of your Personal Information
          for the purposes of targeted advertising.
        </li>
        <li>
          <GreyText>Right to Non-Discrimination:</GreyText> The right not to receive discriminatory treatment for exercising your privacy
          rights.
        </li>
      </List>
      <Box>
        <Text>
          If you are a California resident or otherwise have rights under U.S. Privacy Laws and you
          would like to exercise any of your rights pursuant to this Privacy Statement, please
          email data.privacy@syngenta.com and describe your request, or complete the interactive
          “Email Us” webform available at https://www.syngenta-us.com/contact-us with “U.S.
          Privacy Laws Request” in the subject line and describe your request, or call 1-800-334-
          9481.
        </Text>
      </Box>
      <br />
      <GreyText>Verification Process</GreyText><br />
      <Text>
        After we receive your request, to ensure the security of the information we store and consumers’
        privacy, we will verify that you are appropriately affiliated with the subject of the request, either
        as the consumer or as an authorized agent or guardian of the consumer. We may ask you to
        provide a few pieces of information to confirm your identity in our records.
        Non-Discrimination
      </Text>
      <Text>
        Please note that a legitimate denial of a request for information, deletion, or to opt-out is not
        discriminatory, nor is charging a fee for excessive or repetitive consumer requests as permitted
        by the CCPA.
      </Text>
      <GreyText><u>Authorized Agents</u></GreyText><br />
      <Text>
        You may designate an authorized agent to exercise your rights under the CCPA (or other US
        Privacy Laws if such laws permit) on your behalf.
      </Text>
      <Text>Pursuant to the CCPA:</Text>
      <List>
        <li>
          Only a business entity or natural person registered with the California Secretary of State
          may act as an authorized agent.
        </li>
        <li>
          You must provide the authorized agent written permission to exercise your rights under
          the CCPA on your behalf.
        </li>
        <li>
          We may deny a request from an authorized agent on your behalf if the authorized agent
          does not submit proof that he, she, or it has been authorized by you to act on your behalf
          if we request such proof, as permitted by the CCPA.
        </li>
      </List>
      <Text>
        Even if you use an authorized agent to exercise your rights under the CCPA on your behalf,
        pursuant to the CCPA we may still require that you verify your own identity directly to us.
      </Text>
      <GreyText><u>Personal Information of Minors</u></GreyText><br />
      <Text>
        Our operation of this website, our activity on social media, and our services are not intended for
        children or minors under the age of 16 years old. Accordingly, we do not knowingly collect,
        store, share or sell information about minors under the age of 16. If you believe that we have
        unintentionally received personal information about a minor under the age of 16 years old,
        please contact us at <u>data.privacy@syngenta.com</u>.
      </Text>
      <GreyText><u>Changes</u></GreyText>
      <Text>
        Syngenta reserves the right to amend this Statement, including the Notice, at our discretion and
        at any time.
      </Text>
    </Container>
  )
}